import React from "react";
import classNames from "classnames";
import Direction from "../assets/direction.svg";

export const Arrow = (props: { dir: "right" | "left" | "top" | "bottom" }) => {
    return <span className={classNames("direction", props.dir)} dangerouslySetInnerHTML={{ __html: Direction }} />;
};
